

// buzzwareTech imports
import type { TIssue } from "@buzzwaretech/types";

export const DEFAULT_WORK_ITEM_FORM_VALUES: Partial<TIssue> = {
  project_id: "",
  type_id: null,
  name: "",
  description_html: "",
  estimate_point: null,
  state_id: "",
  parent_id: null,
  priority: "none",
  assignee_ids: [],
  label_ids: [],
  cycle_id: null,
  module_ids: null,
  start_date: null,
  target_date: null,
};
